import * as React from 'react';
import {useUiConfig} from '../../providers/UiConfigProvider';
import {PopoverConfig} from './PopoverConfig';
import {MobilePopover} from './Popover.mobile';
import {DesktopPopover} from './Popover.desktop';
import {useIsWithinListBoxContext} from '../../iframe-overrides/utils';

export const Popover = PopoverConfig.createView((props) => {
  const isWithinListBoxContext = useIsWithinListBoxContext();
  const uiConfig = useUiConfig();
  const isSmallScreen = !!uiConfig?.isSmallScreen;
  const isTouch = !!uiConfig?.isTouch;
  const enabledBottomSheets = !!uiConfig?.enableBottomSheets;

  const isMobileAndBottomSheetEnabled =
    isSmallScreen && isTouch && enabledBottomSheets;

  const PopoverComponent =
    isMobileAndBottomSheetEnabled && !isWithinListBoxContext
      ? MobilePopover
      : DesktopPopover;

  return <PopoverComponent {...props} />;
});
